import { Capacitor } from '@capacitor/core';

export const isNative = () => Capacitor.isNativePlatform();
export const isIOS = () => Capacitor.getPlatform() === 'ios';
export const isAndroid = () => Capacitor.getPlatform() === 'android';
export const isWeb = () => Capacitor.getPlatform() === 'web';
// Stripe checkout has been removed — Apple IAP is the only supported payment path.
export const canShowStripeCheckout = () => false;
export const canShowAppleIAP = () => isIOS();
